import {Injectable}                      from '@angular/core';
import {Api}                             from '../api.service';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable}                      from 'rxjs/Observable';
import {Messagecentral}                  from '../api/messagecentrals/api.models';
import {tap}                             from 'rxjs/operators';
import {Utils}                           from '../utils.service';

@Injectable()
export class MessagecentralsResolver implements Resolve<any> {
    constructor(private api: Api, private utils: Utils) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<Messagecentral[]> {
        return this.api.messagecentrals().collection(100, 0).pipe(
            tap((messagecentrals: Messagecentral[]) => this.utils.sortList(messagecentrals, 'name'))
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/resolvers/messagecentrals.resolver.ts